<template>
  <!-- sidebar menu -->
  <div id="sidebar-menu" class="main_menu_side main_menu">
    <div class="menu_section">
      <ul class="nav side-menu">
        <!-- account -->
        <li v-if="authCategoryState.account">
          <a id="account" @click="toggleMenu('account')" class="nav-child"
            ><i class="fa fa-users"></i> {{ $t('subMenu.accountManagement')
            }}<span class="fa fa-chevron-down"></span
          ></a>
          <ul :class="{ dpb: menu['account'] }" class="nav child_menu">
            <li v-if="authState.user">
              <router-link :to="'/account/user'">{{
                $t('subMenu.userManagement')
              }}</router-link>
            </li>
          </ul>
        </li>
        <!-- order -->
        <li v-if="authCategoryState.order">
          <a id="order" @click="toggleMenu('order')" class="nav-child"
            ><i class="fa fa-cutlery"></i> {{ $t('subMenu.order')
            }}<span class="fa fa-chevron-down"></span
          ></a>
          <ul :class="{ dpb: menu['order'] }" class="nav child_menu">
            <li v-if="authState.item">
              <router-link :to="'/order/item'">{{
                $t('subMenu.itemInformation')
              }}</router-link>
            </li>
            <li v-if="authState.imageUpload">
              <router-link :to="'/order/item/image'">{{
                $t('subMenu.itemImageUpload')
              }}</router-link>
            </li>
            <li v-if="authState.searchTag">
              <router-link :to="{ name: 'searchTag' }">{{
                $t('subMenu.searchConfig')
              }}</router-link>
            </li>
            <!-- <li><a href="#">原材料・原産地・カロリー・アレルゲン情報</a></li> 今回は実装しない -->
            <li v-if="authState.category">
              <router-link :to="'/order/category'">{{
                $t('subMenu.category')
              }}</router-link>
            </li>
            <li v-if="authState.menu">
              <router-link :to="'/order/menu'">{{
                $t('subMenu.menu')
              }}</router-link>
            </li>
            <li v-if="authState.price">
              <router-link :to="'/order/price'">{{
                $t('subMenu.price')
              }}</router-link>
            </li>
          </ul>
        </li>
        <!-- ad -->
        <li v-if="authCategoryState.ad">
          <a id="ad" @click="toggleMenu('ad')" class="nav-child"
            ><i class="fa fa-comments-o"></i> {{ $t('subMenu.ad')
            }}<span class="fa fa-chevron-down"></span
          ></a>
          <ul :class="{ dpb: menu['ad'] }" class="nav child_menu">
            <!-- <li><a href="#">広告</a></li> 今回は実装しない -->
            <li v-if="authState.orderRecommend">
              <router-link :to="'/ad/orderRecommend'">{{
                $t('subMenu.recommendOnOrder')
              }}</router-link>
            </li>
            <li v-if="authState.timeRecommend">
              <router-link :to="'/ad/timeRecommend'">{{
                $t('subMenu.timedRecommend')
              }}</router-link>
            </li>
          </ul>
        </li>
        <!-- event -->
        <li v-if="authCategoryState.event">
          <a id="event" @click="toggleMenu('event')" class="nav-child"
            ><i class="fa fa-calendar"></i> {{ $t('subMenu.eventInformation')
            }}<span class="fa fa-chevron-down"></span
          ></a>
          <ul :class="{ dpb: menu['event'] }" class="nav child_menu">
            <li v-if="authState.event">
              <router-link :to="'/event/event'">{{
                $t('subMenu.eventList')
              }}</router-link>
            </li>
          </ul>
        </li>
        <!-- operation -->
        <li v-if="authCategoryState.operation">
          <a id="operation" @click="toggleMenu('operation')" class="nav-child"
            ><i class="fa fa-gear"></i> {{ $t('subMenu.operationalManagement')
            }}<span class="fa fa-chevron-down"></span
          ></a>
          <ul :class="{ dpb: menu['operation'] }" class="nav child_menu">
            <li v-if="authState.shopSettingAll">
              <router-link :to="'/setting/shopSettingAll'">{{
                $t('subMenu.allShopsConfig')
              }}</router-link>
            </li>
            <li v-if="authState.shop">
              <router-link :to="'/setting/shop'">{{
                $t('subMenu.shopList')
              }}</router-link>
            </li>
            <li v-if="authState.group">
              <router-link :to="{ name: 'group' }">{{
                $t('subMenu.groupConfig')
              }}</router-link>
            </li>
            <li v-if="authState.bikkurapon && !isUs">
              <router-link :to="'/setting/bikkurapon'"
                >{{
                  isJp
                    ? $t('subMenu.sumahoDeBikkurapon-jp')
                    : $t('subMenu.sumahoDeBikkurapon')
                }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <!-- /sidebar menu -->
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      menu: {},
      authState: {
        user: false,
        item: false,
        imageUpload: false,
        category: false,
        menu: false,
        price: false,
        orderRecommend: false,
        timeRecommend: false,
        event: false,
        shopSettingAll: false,
        shop: false,
        bikkurapon: false,
        searchTag: false,
        group: false,
      },
      authCategoryState: {
        // 認証状態のカテゴリー
        account: false,
        order: false,
        ad: false,
        event: false,
        operation: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      getAuthorityList: 'user/getAuthorityList',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
  },
  watch: {
    getAuthorityList: function(authorityList) {
      this.sideMenuDisplay(authorityList)
    },
  },
  mounted() {
    this.sideMenuDisplay(this.getAuthorityList)
    const navChildren = document.querySelectorAll('.nav-child')
    navChildren.forEach((item) => {
      this.menu[item.id] = false
    })
  },
  methods: {
    toggleMenu: function(targetId) {
      const target = document.getElementById(targetId)
      if (target.nextElementSibling.style.display === 'block') {
        target.nextElementSibling.style.display = 'none' // 次の要素を表示する
        target.parentNode.classList.remove('active')
        return
      }
      document.querySelectorAll('.child_menu').forEach((item) => {
        item.style.display = 'none'
        item.parentNode.classList.remove('active')
      })
      target.nextElementSibling.style.display = 'block' // 次の要素を表示する
      target.parentNode.classList.add('active')
    },
    // サイドメニュー出し分けをする
    sideMenuDisplay: function(authorityList) {
      authorityList.some((viewId) => {
        switch (viewId) {
          case 1:
            this.authCategoryState.account = true
            this.authState.user = true
            break

          case 2:
            this.authCategoryState.order = true
            this.authState.item = true
            break

          case 3:
            this.authCategoryState.order = true
            this.authState.imageUpload = true
            break

          case 4:
            this.authCategoryState.order = true
            this.authState.category = true
            break

          case 5:
            this.authCategoryState.order = true
            this.authState.menu = true
            break

          case 6:
            this.authCategoryState.order = true
            this.authState.price = true
            break

          case 7:
            this.authCategoryState.ad = true
            this.authState.orderRecommend = true
            break

          case 8:
            this.authCategoryState.ad = true
            this.authState.timeRecommend = true
            break

          case 9:
            this.authCategoryState.event = true
            this.authState.event = true
            break

          case 10:
            this.authCategoryState.operation = true
            this.authState.shopSettingAll = true
            break

          case 11:
            this.authCategoryState.operation = true
            this.authState.shop = true
            break

          case 12:
            this.authCategoryState.operation = true
            this.authState.bikkurapon = true
            break

          case 13:
            this.authCategoryState.order = true
            this.authState.searchTag = true
            break

          case 14:
            this.authCategoryState.operation = true
            this.authState.group = true
            break
        }
      })
    },
  },
}
</script>
<style scoped>
.dpb {
  display: block;
  transition: all 300ms 0s ease;
}
</style>
